import { useState } from 'react';

const useArticleModalFullscreen = () => {
  const [fullscreenOpen, setFullscreenOpen] = useState(false);
  const [fullscreenZoom, setFullscreenZoom] = useState(50);
  const [fullscreenPageIndex, setFullscreenPageIndex] = useState(0);

  const openFullscreen = (pageIndex = 0) => {
    setFullscreenPageIndex(pageIndex);
    setFullscreenZoom(50);
    setFullscreenOpen(true);
  };

  const closeFullscreen = () => {
    setFullscreenOpen(false);
  };

  const zoomIn = () => {
    setFullscreenZoom(prev => Math.min(prev + 25, 300));
  };

  const zoomOut = () => {
    setFullscreenZoom(prev => Math.max(prev - 25, 25));
  };

  const resetZoom = () => {
    setFullscreenZoom(100);
  };

  return {
    closeFullscreen,
    fullscreenOpen,
    fullscreenPageIndex,
    fullscreenZoom,
    openFullscreen,
    resetZoom,
    zoomIn,
    zoomOut
  };
};

export default useArticleModalFullscreen;


